import React, { useState, useEffect, useRef } from 'react';

import TablaUsuarios from './Tabla/TablaUsuarios';
import Exportar from './Botones/Exportar';
import EliminarUno from './Dialogos/EliminarUno';
import EliminarVarios from './Dialogos/EliminarVarios';
import CrearModificar from './Dialogos/CrearModificar';
import { leftToolbarTemplate } from '../ComponentsCat/Botones/AgregarEliminar'
import { usuarioVacio } from './Objetos/UsuarioVacio';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Service } from '../../../service/Service';
import Spinner from '../../../components/loader/Spinner';
import ErrorSistema from '../../../components/error/ErrorSistema';
import Environment from '../../../Environment'
const getRoute = Environment();

const CrudUsuarios = ({ titulos, notificaciones }) => {
    //--------------------| Inicializacion |--------------------


    //--------------------| Uso de estados |--------------------
    const [products, setProducts] = useState([]);
    const [product, setProduct] = useState(usuarioVacio);
    const [productDialog, setProductDialog] = useState(false);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [deleteProductsDialog, setDeleteProductsDialog] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [tieneId, setTieneId] = useState(false)
    //--> Estilos de inputs
    const [estiloNombre, setEstiloNombre] = useState("")
    const [estiloAP, setEstiloAP] = useState("")
    const [estiloAM, setEstiloAM] = useState("")
    //--> Interaccion con back-end
    const [isLoading, setIsLoading] = useState(false)
    const [loadingModal, setLoadingModal] = useState(false)
    const [error, setError] = useState(null)

    const toast = useRef(null);
    const dt = useRef(null);

    //--------------------| Funciones de Crud |--------------------
    //--> Crear nuevo producto
    const createProduct = async (product) => {
        setIsLoading(true)
        setError(null)
        try {
            let usuarioService = new Service()
            usuarioService.baseUrl += `usuarios`
            await usuarioService.create(product)
            const data = await usuarioService.readAll()
            setProducts(data)
            toast.current.show({ severity: 'success', summary: '¡Atención!', detail: `${notificaciones.creacion}`, life: 3000 });
        } catch (error) {
            toast.current.show({ severity: 'error', summary: '¡Atención!', detail: `${notificaciones.error}`, life: 3000 });
            setError(error.message)
        }
        setIsLoading(false)
    }

    const updateProduct = async (product) => {
        setIsLoading(true)
        setError(null)
        try {
            let usuarioService = new Service()
            usuarioService.baseUrl += `usuarios`
            await usuarioService.update(product)
            const data = await usuarioService.readAll()
            setProducts(data)
        } catch (error) { setError(error.message) }
        setIsLoading(false)
        toast.current.show({ severity: 'success', summary: '¡Atención!', detail: `${notificaciones.modificacion}`, life: 3000 });
    }

    const deleteProduct = async (id) => {
        setIsLoading(true)
        setError(null)
        try {
            let usuarioService = new Service()
            usuarioService.baseUrl += `usuarios`
            await usuarioService.delete(id)
            const data = await usuarioService.readAll()
            setProducts(data)
        } catch (error) { setError(error.message) }
        setIsLoading(false)
        toast.current.show({ severity: 'success', summary: '¡Atención!', detail: `${notificaciones.eliminacion}`, life: 3000 });
    }

    //--------------------| Dialogos |--------------------
    //--> Nuevo gasto
    const openNew = () => {
        setProduct(usuarioVacio);
        setProductDialog(true);
        setEstiloNombre("")
        setEstiloAP("")
        setEstiloAM("")
    }
    //--> Ocultar dialogo crear
    const hideDialog = () => { setProductDialog(false) }
    //--> Ocultar dialogo de eliminar 1 producto
    const hideDeleteProductDialog = () => { setDeleteProductDialog(false) }
    //--> Ocultar dialogo de eliminar varios productos
    const hideDeleteProductsDialog = () => { setDeleteProductsDialog(false) }
    //--> Eliminar 1 producto
    const confirmDeleteProduct = (product) => {
        setProduct(product);
        setDeleteProductDialog(true);
    }
    //--> Eliminar varios productos
    const confirmDeleteSelected = () => { setDeleteProductsDialog(true) }

    //--------------------| Acciones de crud |--------------------
    //------> Actualizar campo de producto
    const updateField = (data, field) => {
        setProduct({
            ...product,
            [field]: data,
        });
    };
    //------> Agregar nuevo registro
    const saveProduct = () => {
        if (!product.id) { createProduct(product) }
        else { updateProduct(product) }
        setProduct(usuarioVacio);
        setProductDialog(false);
    }
    //------> Eliminar 1 producto
    const _deleteProduct = () => {
        deleteProduct(product.id)
        setProduct(usuarioVacio)
        setDeleteProductDialog(false)
    }
    //------> Eliminar varios productos
    const deleteSelectedProducts = () => {
        selectedProducts.forEach(registro => deleteProduct(registro.id))
        setDeleteProductsDialog(false);                                         // Ocultara dialogo
        setSelectedProducts(null);                                              // Elemetos seleccionados = 0
        // toast.current.show({ severity: 'error', summary: 'Atencion!', detail: `${notificaciones.eliminaciones}`, life: 3000 });
    }
    //------> Editar producto
    const _editProduct = async (product) => {
        setIsLoading(true)
        let usuarioService = new Service()
        usuarioService.baseUrl += `usuarios`
        const respuesta = await usuarioService.findById(product.id)// Axios.post(`${getRoute}/usuarios/${product.id}`)

        setProduct(respuesta)
        setIsLoading(false)
        setProductDialog(true)
    }

    //--------------------| Botones en pantalla |--------------------
    //------> Botones para agregar/eliminar productos
    const BotonesCabezal = leftToolbarTemplate(openNew, confirmDeleteSelected, selectedProducts);

    //------> Boton para exportar
    const ExportarRegistros = Exportar(products);

    //------> Botones parte derecha
    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <Button
                    icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                    onClick={() => _editProduct(rowData)} />
            </>
        );
    }

    //--------------------| Obtener registros de back-end |--------------------
    //---> Obtendra los datos del back-end
    useEffect(() => {
        const cargarDatos = async () => {
            setIsLoading(true)
            setError(null)
            try {
                let usuarioService = new Service()
                usuarioService.baseUrl += `usuarios`
                const data = await usuarioService.readAll()
                setProducts(data)
            } catch (error) {
                setError(error.message)
            }
            setIsLoading(false)
        }
        cargarDatos()
        return () => {                                      // Funcion de limpieza
            setProducts([])
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps    

    //--------------------| Abilitar o inhabilitar boton |--------------------
    useEffect(() => {
        // Edicion
        if (product.id) { setTieneId(false) }
        // Creacion
        else { setTieneId(true) }
    }, [product])

    //--------------------| Valor que regresara |--------------------
    return (
        <div className="datatable-crud-demo">
            <Toast ref={toast} />
            {!isLoading && !error && (
                <TablaUsuarios
                    BotonesCabezal={BotonesCabezal}
                    ExportarRegistros={ExportarRegistros}
                    dt={dt}
                    products={products}
                    selectedProducts={selectedProducts}
                    setSelectedProducts={setSelectedProducts}
                    actionBodyTemplate={actionBodyTemplate}
                    openNew={openNew}
                    confirmDeleteSelected={confirmDeleteSelected}
                />)}
            {isLoading && <Spinner />}
            {error && <ErrorSistema texto={error} />}

            <CrearModificar
                productDialog={productDialog}
                titulos={titulos}
                saveProduct={saveProduct}
                hideDialog={hideDialog}
                product={product}
                updateField={updateField}
                tieneId={tieneId}
                estiloAP={estiloAP} setEstiloAP={setEstiloAP}
                estiloAM={estiloAM} setEstiloAM={setEstiloAM}
                loadingModal={loadingModal} setLoadingModal={setLoadingModal}
                estiloNombre={estiloNombre} setEstiloNombre={setEstiloNombre}
            />

            <EliminarUno
                deleteProductDialog={deleteProductDialog}
                _deleteProduct={_deleteProduct}
                hideDeleteProductDialog={hideDeleteProductDialog}
                product={product}
            />

            <EliminarVarios
                deleteProductsDialog={deleteProductsDialog}
                deleteSelectedProducts={deleteSelectedProducts}
                hideDeleteProductsDialog={hideDeleteProductsDialog}
                product={product}
            />
        </div>
    );
}

export default CrudUsuarios;